import React from "react";

const SubscribersOnly = (props: { isAlreadySubscribed: boolean }) => {
  const { isAlreadySubscribed } = props;
  return (
    <div className={"flex items-center gap-3 self-stretch bg-white lg:bg-[#F5F5F5] px-3 py-2 rounded-lg"}>
      <img
        src="/assets/images/subscription-competitions/botb-pass-coin.png"
        alt="botb pass coin"
        width={30}
        height={30}
        className="w-7.5 h-auto"
      />
      <div className={"text-[#696971] font-jost text-xs font-normal leading-4"}>
        <span className={"text-sm font-medium text-black"}>Subscribers competition</span>
        <br />
        {isAlreadySubscribed ? (
          <>{"You’ve been automatically entered in this comp. Entries also available by post"}</>
        ) : (
          <>{"Enter with BOTB Pass or via postal entry. No ticket purchases available."}</>
        )}
      </div>
    </div>
  );
};

export default SubscribersOnly;
